"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ParameterVariableInstance = exports.ParameterVariable = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _VariableType = require("../VariableType");
class ParameterVariable extends _VariableType.VarsValueVariableType {
  constructor() {
    super();
    (0, _defineProperty2.default)(this, "settings", void 0);
    (0, _defineProperty2.default)(this, "type", "parameter");
    (0, _defineProperty2.default)(this, "label", "parameter");
    (0, _defineProperty2.default)(this, "description", "A parameter reference that can be a constant, or a reference to another variable.");
  }
  dependencies(params, resolver) {
    var _resolver$resolve;
    return (_resolver$resolve = resolver.resolve(params.value)) === null || _resolver$resolve === void 0 ? void 0 : _resolver$resolve.value;
  }
  value(deps, batcher) {
    return deps;
  }
}
exports.ParameterVariable = ParameterVariable;
const ParameterVariableInstance = exports.ParameterVariableInstance = new ParameterVariable();
//# sourceMappingURL=ParameterVariable.js.map